import { useEffect, useRef, useState } from "react";
import { Download, X } from "lucide-react";
import { Btn, AMBER, MUTED, LINE } from "./SemaforoUi";

const KEY = "sem_exit_shown";
const seen = () => { try { return !!sessionStorage.getItem(KEY); } catch { return false; } };
const mark = () => { try { sessionStorage.setItem(KEY, "1"); } catch { /* storage bloccato */ } };

// Si apre una sola volta: quando l'utente sta per uscire (mouse verso l'alto su PC, "indietro" su telefono) o dopo 40" senza sbloccare.
export function ExitPopup({ active, mesiLabel, onUnlock }) {
  const [open, setOpen] = useState(false);
  const pushed = useRef(false);

  useEffect(() => {
    if (!active || seen()) return;
    const show = () => { if (!seen()) { mark(); setOpen(true); } };
    const onLeave = (e) => { if (e.clientY <= 0) show(); };
    const onPop = () => { if (!seen()) { window.history.pushState({ sem: 1 }, ""); show(); } };
    if (!pushed.current) { window.history.pushState({ sem: 1 }, ""); pushed.current = true; }
    document.addEventListener("mouseleave", onLeave);
    window.addEventListener("popstate", onPop);
    const t = setTimeout(show, 40000);
    return () => { document.removeEventListener("mouseleave", onLeave); window.removeEventListener("popstate", onPop); clearTimeout(t); };
  }, [active]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4" style={{ background: "rgba(11,17,32,0.82)", backdropFilter: "blur(6px)" }} data-testid="semaforo-exit-popup" onClick={() => setOpen(false)}>
      <div className="w-full max-w-md rounded-2xl p-6 sm:p-7 relative" style={{ background: "#0F1A30", border: `1px solid ${AMBER}` }} onClick={(e) => e.stopPropagation()}>
        <button onClick={() => setOpen(false)} className="absolute top-3 right-3 p-1.5 rounded-full" style={{ color: MUTED }} aria-label="Chiudi" data-testid="semaforo-exit-close"><X size={18} /></button>
        <p className="text-xs font-bold uppercase tracking-[0.25em]" style={{ color: AMBER }}>Un attimo</p>
        <p className="mt-2 font-display font-black text-2xl sm:text-3xl leading-tight">Il vostro Piano Ossigeno è già pronto.</p>
        <p className="mt-3 text-sm sm:text-base leading-relaxed" style={{ color: MUTED }}>
          Le 3 mosse per passare da {mesiLabel} a qualcosa di più, con le vostre cifre già calcolate. In PDF, gratis: bastano nome ed email.
        </p>
        <div className="mt-5"><Btn onClick={() => { setOpen(false); onUnlock(); }} testid="semaforo-exit-unlock"><Download size={18} /> Sì, mandatemelo</Btn></div>
        <button onClick={() => setOpen(false)} className="mt-3 w-full text-sm py-2" style={{ color: MUTED, borderTop: `1px solid ${LINE}` }} data-testid="semaforo-exit-dismiss">No, grazie</button>
      </div>
    </div>
  );
}
